import api from './api';

// Mock data for development
const mockGallery = [
  {
    id: 1,
    title: 'Office Building Project',
    category: 'Commercial',
    imageUrl: 'https://via.placeholder.com/400x300',
    createdAt: '2026-02-15T10:00:00Z'
  },
  {
    id: 2,
    title: 'Bridge Construction',
    category: 'Infrastructure',
    imageUrl: 'https://via.placeholder.com/400x300',
    createdAt: '2026-02-14T10:00:00Z'
  },
  {
    id: 3,
    title: 'Residential Complex',
    category: 'Residential',
    imageUrl: 'https://via.placeholder.com/400x300',
    createdAt: '2026-02-13T10:00:00Z'
  },
  {
    id: 4,
    title: 'Highway Development',
    category: 'Infrastructure',
    imageUrl: 'https://via.placeholder.com/400x300',
    createdAt: '2026-02-12T10:00:00Z'
  },
  {
    id: 5,
    title: 'Shopping Mall Design',
    category: 'Commercial',
    imageUrl: 'https://via.placeholder.com/400x300',
    createdAt: '2026-02-11T10:00:00Z'
  },
  {
    id: 6,
    title: 'Industrial Warehouse',
    category: 'Industrial',
    imageUrl: 'https://via.placeholder.com/400x300',
    createdAt: '2026-02-10T10:00:00Z'
  }
];

const categories = ['Commercial', 'Residential', 'Infrastructure', 'Industrial', 'Interior'];

let galleryData = [...mockGallery];

export const galleryService = {
  getAll: async (params = {}) => {
    if (process.env.NODE_ENV === 'development') {
      return new Promise((resolve) => {
        setTimeout(() => {
          let filtered = [...galleryData];
          
          if (params.search) {
            filtered = filtered.filter(item => 
              item.title.toLowerCase().includes(params.search.toLowerCase())
            );
          }
          
          if (params.category) {
            filtered = filtered.filter(item => item.category === params.category);
          }
          
          resolve({
            data: {
              images: filtered,
              total: filtered.length
            }
          });
        }, 500);
      });
    }
    return api.get('/gallery', { params });
  },

  upload: async (formData) => {
    if (process.env.NODE_ENV === 'development') {
      return new Promise((resolve) => {
        setTimeout(() => {
          const newImages = [];
          const title = formData.get('title') || 'New Image';
          const category = formData.get('category') || 'General';
          
          // Simulate uploading multiple images
          const files = formData.getAll('images');
          files.forEach((file, index) => {
            newImages.push({
              id: Date.now() + index,
              title: `${title} ${index + 1}`,
              category,
              imageUrl: URL.createObjectURL(file),
              createdAt: new Date().toISOString()
            });
          });
          
          galleryData = [...newImages, ...galleryData];
          resolve({ data: newImages });
        }, 1000);
      });
    }
    return api.post('/gallery/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  delete: async (id) => {
    if (process.env.NODE_ENV === 'development') {
      return new Promise((resolve) => {
        setTimeout(() => {
          galleryData = galleryData.filter(g => g.id !== parseInt(id));
          resolve({ data: { message: 'Image deleted successfully' } });
        }, 500);
      });
    }
    return api.delete(`/gallery/${id}`);
  },

  getCategories: async () => {
    if (process.env.NODE_ENV === 'development') {
      return Promise.resolve({ data: categories });
    }
    return api.get('/gallery/categories');
  },

  updateDetails: async (id, data) => {
    if (process.env.NODE_ENV === 'development') {
      return new Promise((resolve) => {
        setTimeout(() => {
          const index = galleryData.findIndex(g => g.id === parseInt(id));
          if (index !== -1) {
            galleryData[index] = { ...galleryData[index], ...data };
            resolve({ data: galleryData[index] });
          }
        }, 300);
      });
    }
    return api.put(`/gallery/${id}`, data);
  }
};
